// Category Manager Component

import api from '../api.js';
import { loadCategories } from './BookmarkList.js';

export function renderCategoryManager() {
  return `
    <div class="modal" id="category-modal">
      <div class="modal-content">
        <div class="modal-header">
          <h2>Kategorien verwalten</h2>
          <button class="modal-close" id="close-category-modal">&times;</button>
        </div>

        <div class="category-manager">
          <div class="category-form">
            <h3>Neue Kategorie</h3>
            <form id="category-form" class="form">
              <div class="form-row">
                <div class="form-group flex-grow">
                  <input
                    type="text"
                    id="category-name"
                    name="name"
                    required
                    placeholder="Kategoriename"
                  >
                </div>
                <div class="form-group">
                  <input
                    type="color"
                    id="category-color"
                    name="color"
                    value="#3b82f6"
                  >
                </div>
                <button type="submit" class="btn btn-primary">Erstellen</button>
              </div>
            </form>
          </div>

          <div class="category-list" id="category-list-manager">
            <h3>Bestehende Kategorien</h3>
            <div id="category-items"></div>
          </div>
        </div>
      </div>
    </div>
  `;
}

export async function initCategoryManager() {
  const form = document.getElementById('category-form');
  if (!form) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    await createCategory();
  });

  document.getElementById('close-category-modal')?.addEventListener('click', closeCategoryManager);

  document.getElementById('category-modal')?.addEventListener('click', (e) => {
    if (e.target.id === 'category-modal') {
      closeCategoryManager();
    }
  });

  await renderCategoryItems();
}

async function renderCategoryItems() {
  try {
    const categories = await api.getCategories();
    const container = document.getElementById('category-items');
    if (!container) return;

    if (categories.length === 0) {
      container.innerHTML = '<p class="text-muted">Noch keine Kategorien vorhanden.</p>';
      return;
    }

    container.innerHTML = categories.map(cat => `
      <div class="category-item" data-id="${cat.id}">
        <div class="category-color" style="background-color: ${cat.color || '#999'}"></div>
        <span class="category-name">${escapeHtml(cat.name)}</span>
        <div class="category-actions">
          <button class="btn-icon delete-category" data-id="${cat.id}" title="Löschen">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="3 6 5 6 21 6"></polyline>
              <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
            </svg>
          </button>
        </div>
      </div>
    `).join('');

    // Attach delete listeners
    container.querySelectorAll('.delete-category').forEach(btn => {
      btn.addEventListener('click', async (e) => {
        const id = parseInt(e.currentTarget.dataset.id);
        await deleteCategory(id);
      });
    });
  } catch (error) {
    console.error('Failed to render categories:', error);
  }
}

async function createCategory() {
  const form = document.getElementById('category-form');
  const formData = new FormData(form);

  const data = {
    name: formData.get('name'),
    color: formData.get('color'),
  };

  try {
    await api.createCategory(data);
    showSuccess('Kategorie erstellt');
    form.reset();
    await renderCategoryItems();
    await loadCategories();
  } catch (error) {
    console.error('Failed to create category:', error);
    showError('Fehler beim Erstellen: ' + error.message);
  }
}

async function deleteCategory(id) {
  if (!confirm('Möchten Sie diese Kategorie wirklich löschen? Lesezeichen werden in "Unkategorisiert" verschoben.')) {
    return;
  }

  try {
    await api.deleteCategory(id);
    showSuccess('Kategorie gelöscht');
    await renderCategoryItems();
    await loadCategories();
  } catch (error) {
    console.error('Failed to delete category:', error);
    showError('Fehler beim Löschen: ' + error.message);
  }
}

function closeCategoryManager() {
  const modal = document.getElementById('category-modal');
  if (modal) {
    modal.remove();
  }
}

function escapeHtml(text) {
  if (!text) return '';
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}

function showError(message) {
  const event = new CustomEvent('show-notification', {
    detail: { type: 'error', message }
  });
  document.dispatchEvent(event);
}

function showSuccess(message) {
  const event = new CustomEvent('show-notification', {
    detail: { type: 'success', message }
  });
  document.dispatchEvent(event);
}
